import React, { Component } from 'react';
import cn from 'classnames';
import styles from './style.scss';

import Button from '../../../../common/Button/Button';
import Checkbox from '../../../../common/Checkbox/Checkbox';
import tracker from '../../../../../services/tracker';
import i18n from '../../../../../i18n';
import { withTranslation } from 'react-i18next';

const variants = {
  prkng: { param: 'prkng', key: 'parking', text: i18n.t('components.header.filtersBar.filters.advantages.parking'), event: 'Web_Filters_Parking' },
  elvtr: { param: 'elvtr', key: 'elevator', text: i18n.t('components.header.filtersBar.filters.advantages.elevator'), event: 'Web_Filters_Recreation_Elevator' },
  cncrg: { param: 'cncrg', key: 'concierge', text: i18n.t('components.header.filtersBar.filters.advantages.concierge'), event: 'Web_Filters_Concierge' },
  chldrn: { param: 'chldrn', key: 'childrenArea', text: i18n.t('components.header.filtersBar.filters.advantages.childrenArea'), event: 'Web_Filters_Children_Playground' },
  rcrtzn: { param: 'rcrtzn', key: 'recreationZone', text: i18n.t('components.header.filtersBar.filters.advantages.recreationZone'), event: 'Web_Filters_Recreation_Area' },
  pool: { param: 'pool', key: 'pool', text: i18n.t('components.header.filtersBar.filters.advantages.pool'), event: 'Web_Filters_Swimming_Pool' },
  housetrr: { param: 'housetrr', key: 'houseTerritory', text: i18n.t('components.header.filtersBar.filters.advantages.houseTerritory'), event: 'Web_Filters_House_Territory' }
};

const defaultAdvantages = {
  parking: false,
  elevator: false,
  childrenArea: false,
  concierge: false,
  recreationZone: false,
  pool: false,
  houseTerritory: false
};

const checkIsOnePropDefiend = (obj) => {
  let isOneDefiend = false;
  Object.keys(obj).map(key => {
    if (obj[key]) isOneDefiend = true;
  });
  return isOneDefiend;
};

export const parseSearch = (search) => {
  const { parking, elevator, concierge, childrenArea, recreationZone, pool, houseTerritory } = search;
  return { parking, elevator, concierge, childrenArea, recreationZone, pool, houseTerritory };
};

export const compileSearch = (advantages) => {
  const request = {};
  Object.keys(advantages).map(key => {
    if (advantages[key]) {
      request[key] = true;
    } else {
      request[key] = undefined;
    }
  });
  return request;
};

export const compileRequest = (advantages) => {
  const request = {};
  Object.keys(advantages).map(key => {
    if (advantages[key]) {
      request[key] = true;
    } else {
      request[key] = undefined;
    }
  });

  return request;
};

export const getRequest = (search) => compileRequest(parseSearch(search));

// export const subtext = (search) => {
//   const advantages = parseSearch(search);
//   return Object.keys(variants)
//     .reduce((prev, cur) => {
//       const variant = variants[cur];
//       if (keys.includes(variant.key)) {
//         prev.push(variant.text);
//       }
//       return prev;
//     }, [])
//     .join(', ') || 'Не выбрано';
// };

class Advantages extends Component {
  constructor(props) {
    super(props);

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
  }

  handleClearClick() {
    const { search, dropdownData } = this.props;
    const advantages = parseSearch(search);
    const compiledSearch = compileSearch(defaultAdvantages);
    const compiledRequest = compileRequest(defaultAdvantages);
    dropdownData(compiledSearch, compiledRequest);
    this.props.onClearClick(Object.keys(advantages));
  }

  handleCheckboxClick(key, add) {
    const { search, dropdownData, eventData } = this.props;
    const advantages = parseSearch(search);

    tracker.sendVariantEvent({ variants, key, selected: add, eventData });

    if (add) {
      advantages[key] = true;
    } else {
      advantages[key] = undefined;
    }
    const compiledSearch = compileSearch(advantages);
    const compiledRequest = compileRequest(advantages);
    dropdownData(compiledSearch, compiledRequest);
  }

  checkbox(key) {
    const { search, additional } = this.props;
    const advantages = parseSearch(search);
    const variant = variants[key];
    return (
      <Checkbox
        className={styles.Checkbox}
        innerStyle={styles.FiltersCheckInner}
        classNameClone="CheckboxCloneFilters"
        checked={advantages[variant.key]}
        handle={this.handleCheckboxClick.bind(undefined, variant.key)}
        additional={additional}
        text={variant.text}
      />
    );
  }

  render() {
    const { className, additional, search, isCottegePage, t } = this.props;
    const advantages = parseSearch(search);
    const isAdvatagesDefiend = checkIsOnePropDefiend(advantages);

    return (
      <div className={cn(styles.Menu, className, { [styles.Additional]: additional })}>
        <p className={styles.Title}>
          {t('components.header.filtersBar.filters.advantages.title')}
          {!additional ? (
            isAdvatagesDefiend &&
            <Button className={styles.Button} onClick={this.handleClearClick}>
              {t('components.header.filtersBar.filters.advantages.clear')}
            </Button>
          ) : (null)}
        </p>
        {isCottegePage ?
          <div className={styles.Checkboxes}>
            <div className={styles.FirstColumn}>
              {this.checkbox('prkng')}
              {this.checkbox('elvtr')}
            </div>
            <div className={styles.SecondColumn}>
              {this.checkbox('pool')}
              {this.checkbox('housetrr')}
            </div>
            <div className={styles.ThirdColumn}>
              {this.checkbox('rcrtzn')}
              {this.checkbox('chldrn')}
            </div>
          </div>
          :
          <div className={styles.Checkboxes}>
            <div className={styles.FirstColumn}>
              {this.checkbox('prkng')}
              {this.checkbox('elvtr')}
              {this.checkbox('pool')}
            </div>
            <div className={styles.SecondColumn}>
              {this.checkbox('cncrg')}
              {this.checkbox('housetrr')}
            </div>
            <div className={styles.ThirdColumn}>
              {this.checkbox('rcrtzn')}
              {this.checkbox('chldrn')}
            </div>
          </div>
        }
        {additional ? (
          <div className={styles.ButtonWrap}>
            {isAdvatagesDefiend &&
              <Button className={styles.Button} onClick={this.handleClearClick}>
                {t('components.header.filtersBar.filters.advantages.clear')}
              </Button>}
          </div>
        ) : (null)}
      </div>
    );
  }
}

export default withTranslation()(Advantages);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Advantages/Advantages.js